// 0 - no customerId change occurs but in ui alone All Customers will be set in disable
// 1 - all customer option selected disabled
// 2 - customer specific options and first customer will be selected if no customer ID
// 3 - both all customer and customer specific options and selected cutomer or all customer
// -1 - abrupt dropdown disable


export const dropdownConfigforModules = {
    //Home
    HOME:2,
    HOME_CUSTOMER_SUMMARY:3,
    
    // for settings -------------------------
    USER_MANAGEMENT: 1,
    ROLE: 1,
    GROUPS: 2,
    REBRANDING: 3,
    CREDENTIAL_MANAGER: 2,
    ACTIVITY: 3,
    TWO_FA_SETTINGS: 1,
    IP_RESTRICTION: 1,
    SESSION_SETTINGS: 1,
    AGENT_PROTECTION: 1,
    DATA_CLEANUP_SETTINGS: 1,
    PERSONALIZATION: 1,
    CUSTOMERS:1,
    SUBSCRIPTIONS: 1,
    OFFERS: 1,
    CUSTOM_FIELDS:2,
    CUSTOM_DATA:2,

    // for inventory ----------------------------------
    INVENTORY_CUSTOMER_SUMMARY:3,
    INVENTORY_OVERVIEW: 2,
    INVENTORY_DEVICES: 2,
    INVENTORY_DEVICE_INFO:-1,
    INVENTORY_SOFTWARE: 2,
    INVENTORY_SOFTWARE_INFO:-1,
    INVENTORY_HARDWARE: 2,
    INVENTORY_HARDWARE_INFO:-1,
    GEO_LOCATION: 2,
    SOFTWARE_LICENSE: 2,
    SOFTWARE_METERING: 2,
    SCAN_DEVICE: 2,
    SCHEDULE_SCAN: 2,
    SCAN_SETTINGS: 2,
    SOFTWARE_CATEGORY: 2,
    APPLICATION_CONTROL: 2,
    DEVICE_WARRANTY:2,

    // for enrollment -----------------------------------
    DEPLOYMENT: 2,
    DOMAIN: 2,
    CONNECTOR: 2,
    BULK_DEPLOYMENT_DOWNLOAD: 2,

    // for alerts ------------------------------------
    ALERTS_GENERATED: 3,
    ALERT_POLICY: 2,
    ALERT_ASSOCIATE_POLICY: 2,

    // remote ----------------------
    REMOTE_CONTROL: 2,
    REMOTE_SUPPORT: 2,
    WAKE_ON_LAN: 2,
    SHUTDOWN: 2,
    USER_CONFIRMATION: 2,
    PREFERENCES: 2,
    CONFIGURE_WOL: 2,
    RECORDING: 2,

    //for reports-----------------------
    FAVOURITE_REPORTS: 2,
    CUSTOM_REPORTS:2,
    SCHEDULE_REPORTS:2,
    REPORTS_CATEGORY:2,

    //for manage
    MANAGE_DEVICES_AND_GROUPS_OVERVIEW:-1,
    MANAGE_DEVICES_AND_GROUPS: 2,
    CONFIGURATION_PROFILES: 2,
    DEPLOYMENT_PROFILES: 2,
    SOFTWARE_DEPLOYMENT: 2,
    SCRIPTS: 2,

    //for patch
    VULNERABILITIES: 2,
    PATCH_CUSTOMER_SUMMARY:3,
    MISSING_PATCHES: 2,
    INSTALLED_PATCHES: 2,
    ALL_PATCHES: 2,
    SCAN_DEVICES_PATCH: 2,
    SCAN_SYSTEM: 2,
    MANUAL_DEPLOYMENT: 2,
    ZERO_DAY: 2,
    APD: 2,
    TEST_AND_APPROVE: 2,
    BANDWIDTH_OPTIMIZATION:2,
    PORT_AUDIT:2,
    PATCH_DB:2,
    PATCH_REPORTS: 2,
    VULNERABILITY_REPORTS: 2,
    PORT_AUDIT:2,
    // APD_CUSTOMER_SUMMARY:3,
};